export const ordersTableFeatures = {
  // Temporary hide estimated execution price because it requires rework and retest
  DISPLAY_EST_EXECUTION_PRICE: false,
  DISPLAY_EXECUTION_TIME: false,
}
